import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { MdDownloadForOffline } from 'react-icons/md';
import { AiTwotoneDelete } from 'react-icons/ai';
import { BsFillArrowUpRightCircleFill } from 'react-icons/bs';
import { client, urlFor } from '../../client';
import { fetchUser } from '../../utils/FetchUser';
import { useAlert } from 'react-alert';

const Vid = ({vid}) => {
  const [postHovered, setPostHovered] = useState(false);
  const [savingPost, setSavingPost] = useState(false);
  const alert = useAlert();
  const navigate = useNavigate();

  const { postedBy, video, _id, familyName } = vid;

  const user = fetchUser();


  const deleteVid = (id) => {
    client
      .delete(id)
      .then(() => {
        window.location.reload();
      });
  };
  
  return (
    <div className="m-2 bg-secondaryColor rounded-lg">
    <div className='flex justify-between'>
      <Link to={`/user-profile/${postedBy?._id}`} className="flex gap-2 mt-2 items-center p-1">
        <img
          className="w-8 h-8 rounded-full object-cover"
          src={postedBy?.profUrl}
          alt="user-profile"
        />
        <p className="font-semibold capitalize">{postedBy?.userName}</p>
      </Link>
      <p className='flex items-center text-xs mt-2 p-1'>(video)</p>
      <p className='flex items-center text-xs mt-2 p-1'>{familyName[0] ? familyName[0] : ""}</p>
    </div>
    {/* <p className='items-center justify-center justify-items-center text-center'>{vid?.title}</p> */}
    <div
      onMouseEnter={() => setPostHovered(true)}
      onMouseLeave={() => setPostHovered(false)}
      onClick={() => navigate(`/vid-detail/${_id}`)}
      className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
    >
      {video && 
        // <img className="rounded-lg w-full " src={video} alt="user-post" />)}
        <video
            src={video}
            type="video/mp4"
            controls={false}
            muted
            className="w-full rounded-lg"
          />
      }
      {postHovered && (
        <div
          className="absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50"
          style={{ height: '100%' }}
        >
          <div className="flex items-center justify-between">
            <div className="flex gap-2">
              {/* <a
                href={`${image?.asset?.url}?dl=`}
                download
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="bg-white w-9 h-9 p-2 rounded-full flex items-center justify-center text-dark text-xl opacity-75 hover:opacity-100 hover:shadow-md outline-none"
              ><MdDownloadForOffline />
              </a> */}
            </div>
          </div>
          <div className=" flex justify-between items-center gap-2 w-full">
            {
              postedBy?._id === user?.sub && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    alert.show(
                      <div style={{ color: 'white' }}>
                        Confirm deletion of post?
                        <div className='justify-center'>
                          <button
                            type="button"
                            onClick={(e) => {
                              deleteVid(_id);
                            }}
                            className="bg-indigo-500 text-white font-bold p-2 rounded-full w-20 outline-none justify-center"
                          >
                            Confirm
                          </button>
                        </div>
                      </div>);
                  }}
                  className="bg-white p-2 rounded-full w-8 h-8 flex items-center justify-center text-dark opacity-75 hover:opacity-100 outline-none"
                >
                  <AiTwotoneDelete />
                </button>
              )
            }
          </div>
        </div>
      )}
    </div>
    <p className='items-center justify-center justify-items-center text-center'>{vid?.body}</p>
  </div>
  )
}

export default Vid